import type { FaireProductEntity } from "../../entity_types/product";

export const p_a2v9zajsbw: FaireProductEntity = {
  token: "p_a2v9zajsbw",
  type: "product",
  name: "14.5\" x 19.5\" Poly Mailers - Pack of 50",
  brandToken: "b_ajaj2rm3ar",
  brandName: "Store Supply Warehouse",
  imageUrl: "https://cdn.faire.com/fastly/4da07e489e055dbc3cbc23d4576fc26749b5abdf0bfbe2aed1f04858bdbc0b0f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/e06c15f9298f0dc9976cf114b5716264ce383db5884bf15129a73c6418727edd.jpeg",
    "https://cdn.faire.com/fastly/de0bbb0e9f541bff2e39989968b407859164a92ab07a00d0b1ff1d88dbe38e42.jpeg",
    "https://cdn.faire.com/fastly/8742d69066eac36f11426a1d1d470672203d275781a140813040e9bfc57e8d77.jpeg",
    "https://cdn.faire.com/fastly/e425a78e21184fda9a12cceffcae598b659e2d877566fe81e344b4ed61e6a5b7.jpeg"
  ],
  priceDollars: 15.5,
  description: "Larger 14.5\" x 19.5\" polyethylene mailers for folded garments, textiles and other soft goods. Lightweight polyethylene helps protect contents from moisture, dirt and everyday handling.\n\n- Size: 14.5\" W x 19.5\" H\n- Material: polyethylene\n- Self-sealing adhesive closure, no tape needed\n- Quantity: 50 mailers per pack\n\nKeep a supply on hand for bigger apparel orders.",
  tags: [],
  msrpDollars: 23.25,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-28T21:05:07.699Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
